if (!customElements.get('gift-redeem-button')) {
  customElements.define(
    'gift-redeem-button',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.redeem.bind(this));
      }

      redeem() {
        if (!this.querySelector('img')) {
          this.textContent = 'Adding...';
        }
        this.style.pointerEvents = 'none';
        this.style.opacity = '0.5';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(this.dataset.variantId),
                quantity: 1,
                properties: { _is_free: 'true' },
              },
            ],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status) return;
            const drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.renderContents(data);
          });
      }
    }
  );
}

if (!customElements.get('gift-choice-modal')) {
  customElements.define(
    'gift-choice-modal',
    class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        // Bind triggers (anywhere in the document) targeting this modal
        const targetId = this.dialog.id;
        this._onTriggerClick = (event) => {
          const trigger = event.target.closest(`[data-modal-target="${targetId}"]`);
          if (!trigger) return;
          event.preventDefault();
          if (typeof this.dialog.showModal === 'function') {
            this.dialog.showModal();
          } else {
            this.dialog.setAttribute('open', '');
          }
        };
        document.addEventListener('click', this._onTriggerClick);

        // Close on × button or backdrop click
        this.dialog.addEventListener('click', (event) => {
          if (event.target.closest('[data-close]')) {
            this.dialog.close();
            return;
          }
          // Backdrop click: clicking on dialog element itself (not its content)
          if (event.target === this.dialog) {
            this.dialog.close();
          }
        });
      }

      disconnectedCallback() {
        if (this._onTriggerClick) {
          document.removeEventListener('click', this._onTriggerClick);
        }
      }
    }
  );
}

if (!customElements.get('gift-auto-remove')) {
  customElements.define(
    'gift-auto-remove',
    class extends HTMLElement {
      connectedCallback() {
        const line = parseInt(this.dataset.line);
        this.remove();

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: line,
            quantity: 0,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status) return;
            const drawer = document.querySelector('cart-drawer');
            if (drawer) drawer.renderContents(data);
          });
      }
    }
  );
}
